import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toaster } from '../../../components';
import './DocumentsToaster.scss';
export const DocumentsToaster = ({ isOpen, supportedDocuments, onClose, onClick }) => {
    const { t } = useTranslation();
    const handleClick = (documentType) => {
        onClick(documentType);
        onClose();
    };
    return (React.createElement(Toaster, { isOpen: isOpen, onClose: onClose },
        React.createElement("h2", { className: "documents-toaster__title" }, t('documents_toaster.title')),
        React.createElement("div", { className: "documents-toaster__content" }, supportedDocuments.map((document) => (React.createElement("button", { key: document, className: "documents-toaster__content__document-button", onClick: () => handleClick(document), type: "button" }, t(`common.${document.toLowerCase()}`)))))));
};
//# sourceMappingURL=DocumentsToaster.js.map